"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeFieldFilters = mergeFieldFilters;
function mergeFieldFilters(filter, field1, field2, mergedField, reverseMergeOrder = false) {
    const filter1 = findFieldFilter(filter, field1);
    const mergedFilter = findFieldFilter(filter, mergedField);
    if (isArrayFilterValue(filter1) && !mergedFilter) {
        const filter2 = findFieldFilter(filter, field2);
        if (isArrayFilterValue(filter2)) {
            const filterValues = [filter1.value, filter2.value];
            if (reverseMergeOrder) {
                filterValues.reverse();
            }
            return [
                {
                    column: mergedField,
                    op: 'overlap',
                    value: buildMergedFilterValue(filterValues[0], filterValues[1]),
                },
            ];
        }
        else {
            return [
                {
                    column: field1,
                    op: 'overlap',
                    value: filter1.value,
                },
            ];
        }
    }
    else {
        return undefined;
    }
}
function buildMergedFilterValue(firstFilterValues, lastFilterValues) {
    const result = [];
    firstFilterValues.forEach((firstPart) => {
        lastFilterValues.forEach((lastPart) => result.push(firstPart + '_' + lastPart));
    });
    return result;
}
function isArrayFilterValue(filter) {
    return !!filter && Array.isArray(filter.value) && filter.value.length > 0;
}
function findFieldFilter(filter, field) {
    return filter.find((f) => f.field === field);
}
